import { render, staticRenderFns } from "./DocHero.vue?vue&type=template&id=11976cb4&scoped=true&"
import script from "./DocHero.vue?vue&type=script&lang=js&"
export * from "./DocHero.vue?vue&type=script&lang=js&"
import style0 from "./DocHero.vue?vue&type=style&index=0&id=11976cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11976cb4",
  null
  
)

export default component.exports